module.exports = __webpack_public_path__ + "img/x-gray.2cb1ffe4.svg";